import { navEn } from "./modules/nav.en";
import { dealsEn } from "./modules/deals.en";
import { dealShowEn } from "./modules/deal_show.en";
import { dealImportEn } from "./modules/deal_import.en";
import { reportsEn } from "./modules/reports.en";
import { exportEn } from "./modules/export.en";
import { dashboardEn } from "./modules/dashboard.en";
import { dialerEn } from "./modules/dialer.en";
import { softphoneEn } from "./modules/softphone.en";
import { automationEn } from "./modules/automation.en";
import { notificationsEn } from "./modules/notifications.en";
import { healthEn } from "./modules/health.en";
// GAVION: batch 7
import { privacyEn } from "./modules/privacy.en";
import { callSettingsEn } from "./modules/call_settings.en";
// GAVION X1: daily goals and leaderboard
import { goalsEn } from "./modules/goals.en";
// GAVION X3: data quality
import { dataQualityEn } from "./modules/data_quality.en";
// GAVION open-pixel: Settings → Email
import { emailSettingsEn } from "./modules/email_settings.en";
// GAVION batch 6
import { meetingsEn } from "./modules/meetings.en";
// GAVION batch 6
import { integrationsEn } from "./modules/integrations.en";
// GAVION batch 3: M365 catalogs
import { integrationsM365En } from "./modules/integrations.m365.en";
import { systemSenderEn } from "./modules/system_sender.en"; // GAVION pw-reset-delegated
import { stripeEn } from "./modules/stripe.en"; // GAVION stripe-sync
import { composeEn } from "./modules/compose.en";
// GAVION batch 5: email catalogs (src/components/gavion/email/i18n)
import { emailEn } from "../email/i18n";
// GAVION X2: objection library
import { objectionsEn } from "./modules/objections.en";
// GAVION X5: best call hours
import { callHoursEn } from "./modules/call_hours.en";
// GAVION A10: Profile password change
import { profilePasswordEn } from "./modules/profile_password.en";
// GAVION training (« Formation »)
import { trainingEn } from "./modules/training.en";
// GAVION rep stats
import { repStatsEn } from "./modules/rep_stats.en";
import { costsEn } from "./modules/costs.en";
import { sessionsEn } from "./modules/sessions.en"; // GAVION team sessions
import { aiEn } from "./modules/ai.en"; // GAVION ai-email
import { bookingEn } from "./modules/booking.en"; // GAVION booking
import { testModeEn } from "./modules/test_mode.en"; // GAVION test mode
import { pipelineEn } from "./modules/pipeline.en"; // GAVION custom pipeline
import { leadStatusesEn } from "./modules/lead_statuses.en"; // GAVION lead statuses
import { commissionsEn } from "./modules/commissions.en"; // GAVION commissions
import { commissionsSettingsEn } from "./modules/commissions_settings.en";
import { commissionsClientEn } from "./modules/commissions_client.en";
import { commissionsReportsEn } from "./modules/commissions_reports.en";
import { sendPipelineEn } from "./modules/send_pipeline.en"; // GAVION call-brief-pipeline
import { callBriefEn } from "./modules/call_brief.en"; // GAVION call-brief-pipeline
import { recruitingEn } from "./modules/recruiting.en"; // GAVION recruiting
import { emailArchiveEn } from "./modules/email_archive.en"; // GAVION full-email
import { callbacksEn } from "./modules/callbacks.en"; // GAVION skip-callback
import { tasksEn } from "./modules/tasks.en"; // GAVION tasks page
export const gavionEnMessages = {
  gavion: {
    login: {
      title: "Sign in",
      microsoft: "Sign in with Microsoft",
      or: "or",
      submit: "Sign in",
      forgot: "Forgot password?",
      forgot_ask_admin:
        "Password reset by email is not active yet. Ask an administrator for a password link (Settings → Users → Password link).",
      back_to_login: "Back to sign in",
      // GAVION self-service password reset (gavion-password-reset)
      forgot_details:
        "Enter your email: if an account exists, you will receive a link to choose a new password.",
      forgot_submit: "Send me the link",
      forgot_sent:
        "If an account exists for this address, an email has been sent. The link is valid for 30 minutes and can be used only once.",
      forgot_fallback:
        "Nothing after a few minutes? Check your junk mail, then ask an administrator for a password link (Settings → Users → Password link).",
      forgot_error:
        "The request could not be sent. Try again, or ask an administrator for a password link.",
      dismiss: "Dismiss",
      tagline: "Your business, always on.",
      bullets: {
        faster_calls: "Faster calls",
        auto_followups: "Automatic follow-ups",
        one_place: "Everything in one place",
      },
      errors: {
        invalid_credentials: "Invalid email or password.",
        disabled: "This account is disabled. Contact an administrator.",
        not_invited:
          "No Gavion CRM account for this address. Ask an administrator for an invitation.",
        network: "Cannot connect. Check your network.",
        rate_limited: "Too many attempts. Try again in a few minutes.",
        unknown: "Something went wrong. Please try again.",
      },
    },
    users: {
      title: "Users",
      invite: "Invite a user",
      role: { admin: "Administrator", rep: "Sales rep" },
      status: { active: "Active", invited: "Invited", disabled: "Disabled" },
      can_dial: "Can make calls",
      integration_state: {
        connected: "Yes",
        needs_reauth: "Reconnect",
        error: "Error",
        none: "No",
      },
      resend: "Resend invitation",
      password_link: "Password link",
      revoke: "Revoke invitation",
      disable: "Disable",
      enable: "Enable",
      last_admin: "Not allowed: at least one administrator must remain.",
      never: "Never",
      retry: "Retry",
      load_error: "Could not load users.",
      confirm_disable: "Disable %{name}? Their sessions will be closed.",
      columns: {
        name: "Name",
        email: "Email",
        role: "Role",
        status: "Status",
        last_sign_in: "Last sign-in",
        microsoft: "Microsoft connected",
        granola: "Granola connected",
        actions: "Actions",
      },
      dialog: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        role: "Role",
        locale: "Language",
        locale_fr: "French",
        locale_en: "English",
        send: "Send",
        confirm: "Confirm",
        cancel: "Cancel",
      },
      link: {
        created:
          "Invitation created. Send this link to %{name} (via Teams or email). It is valid for 24 hours and can be used only once.",
        private_window:
          "Open the link in a private window if you test it yourself.",
        field: "Invitation link",
        copy: "Copy link",
        password_created:
          "Send this link to %{name}. It is valid for 24 hours and can be used only once.",
        password_field: "Password link",
        copied: "Link copied!",
        copy_failed: "Select the link and press Ctrl+C",
        close: "Close",
      },
      toast: {
        invited: "Invitation sent.",
        resent: "Invitation resent.",
        revoked: "Invitation revoked.",
        role_changed: "Role updated.",
        disabled: "User disabled.",
        enabled: "User re-enabled.",
        can_dial: "Calling permission updated.",
      },
      errors: {
        invalid_email: "Enter a valid email address.",
        first_name_required: "First name is required.",
        last_name_required: "Last name is required.",
        invalid_role: "Invalid role.",
        invalid_locale: "Invalid language.",
        invalid_id: "Invalid identifier.",
        invalid_disabled: "Invalid value.",
        invalid_can_dial: "Invalid value.",
        already_invited: "This email already has a pending invitation.",
        already_member: "This email already belongs to a user.",
        forbidden: "This action is reserved for administrators.",
        invitation_not_found: "Invitation not found or already handled.",
        not_found: "User not found.",
        unknown: "Something went wrong. Try again.",
      },
    },
    common: { language: "Language", sign_out_all: "Sign out of all devices" },
    // GAVION batch 1: leads, lead page, timeline and CSV import catalogs
    prospect_status: {
      new: "New",
      in_progress: "In progress",
      callback: "Callback",
      demo_booked: "Demo booked",
      in_pipeline: "In pipeline", // GAVION call-brief-pipeline
      not_interested: "Not interested",
      bad_number: "Bad number",
      do_not_call: "Do not call",
      customer: "Customer",
      cooling_down: "Cooling down",
    },
    // Last call labels beside the status (badge, « Last call » filter)
    lead_status: {
      no_answer: "No answer",
      voicemail: "Voicemail left",
      callback: "Callback",
      brochure_sent: "Brochure sent",
      demo_booked: "Demo booked",
      not_interested: "Not interested",
      age: { minutes: "%{n} min ago", hours: "%{n} h ago", days: "%{n} d ago" },
    },
    call_outcome: {
      no_answer: "No answer",
      voicemail: "Voicemail",
      talked_callback: "Talked – call back",
      demo_booked: "Demo booked",
      brochure_sent: "Brochure sent",
      not_interested: "Not interested",
      wrong_number: "Wrong number",
      do_not_call: "Do not call",
      unlogged: "Not logged",
      skipped: "Skipped",
    },
    leads: {
      title: "Leads",
      views: {
        today: "Call today",
        callbacks: "Callbacks",
        mine: "My leads",
        unassigned: "Unassigned",
        demos: "Demos",
        dnc: "Do not call",
        all: "All",
      },
      columns: {
        name: "Company",
        trade: "Trade",
        city: "City",
        phone: "Phone",
        status: "Status",
        last_called_at: "Last call",
        next_callback_at: "Next callback",
        attempts: "Attempts",
        assigned: "Assigned to",
        score: "Score",
      },
      filters: {
        title: "Filters",
        search: "Search",
        trade: "Trade",
        region: "Region",
        city: "City",
        status: "Status",
        last_outcome: "Last call",
        never_called: "Never called",
        score_min: "Min score",
        score_max: "Max score",
        has_email: "Has email",
        high_quality: "High quality",
        assigned: "Assigned to",
        unassigned: "Unassigned",
        tags: "Tags",
        date_added_from: "Added from",
        date_added_to: "Added until",
        more: "More criteria",
        assigned_by_view: "Set by the view",
      },
      badges: { locked: "On a call", dnc: "Do not call" },
      bulk: {
        title: "Bulk actions",
        tag: "Tag",
        tag_title: "Add a tag",
        tag_label: "Tag",
        assign: "Assign",
        assign_title: "Assign to a rep",
        assign_to: "Rep",
        unassign: "Unassigned",
        dnc: "Do not call",
        dnc_confirm_title:
          "Mark %{smart_count} lead as do not call? |||| Mark %{smart_count} leads as do not call?",
        dnc_confirm_body:
          "The numbers are added to the suppression list. Only an admin can remove them.",
        apply: "Apply",
        cancel: "Cancel",
        done_assign:
          "%{smart_count} lead assigned |||| %{smart_count} leads assigned",
        done_assign_partial: "%{ok}/%{total} leads assigned",
        done_dnc:
          "%{smart_count} lead marked do not call |||| %{smart_count} leads marked do not call",
        done_tag: "Tag added",
        // GAVION B1-T7 polish: partial bulk tag result
        done_tag_partial: "%{ok}/%{total} leads tagged",
        tag_failed:
          "%{failed} lead not tagged. It stays selected. |||| %{failed} leads not tagged. They stay selected.",
        error: "The action failed. Try again.",
        not_allowed: "This action is not allowed for your role.",
      },
      empty: {
        today: "No lead to call right now.",
        callbacks: "No callback scheduled.",
        default: "No lead matches.",
      },
      overdue: "Overdue",
      clear_filters: "Clear filters",
      load_error: "Could not load leads.",
      retry: "Retry",
    },
    // GAVION company-create: « Create … » in the company field of the contact / deal form
    company_create: {
      pending: "Creating “%{item}”…",
      existing: "Existing company selected: %{name}",
      invalid_name: "The company name is empty.",
      error:
        "The company could not be created. Check your connection and try again.",
      choose: {
        title: "Several companies are named “%{name}”",
        description: "Pick the right branch, or create a new company.",
        create_anyway: "Create anyway",
        cancel: "Cancel",
      },
    },
    lead: {
      header: {
        add_note: "Add a note",
        more: "More actions",
        assign: "Assign…",
        assign_me: "Assign to me",
        dnc: "Do not call",
        delete: "Delete",
        locked: "Locked: call in progress",
      },
      sections: {
        coordinates: "Contact details",
        prospecting: "Prospecting",
        contacts: "Contacts",
        deals: "Open deals",
        tags: "Tags",
      },
      fields: {
        phone: "Phone",
        email: "Email",
        website: "Website",
        address: "Address",
        map: "View on map",
        segment: "Segment",
        fit_score: "Score",
        high_quality: "High quality",
        employees: "Employees (est.)",
        ops_contact: "Head of operations", // GAVION ops-lookup
        attempts: "Attempts",
        last_outcome: "Last outcome",
        last_called_at: "Last call",
        next_callback_at: "Next callback",
        cooldown_until: "Cooling down until",
        date_added: "Added on",
        source_query: "Source",
        assigned: "Assigned to",
        unassigned: "Unassigned",
        yes: "Yes",
        no: "No",
      },
      no_contacts: "No contact",
      add_contact: "Add a contact", // GAVION company-create
      no_deals: "No open deal",
      note: {
        title: "New note",
        placeholder: "Your note…",
        save: "Save",
        saved: "Note added",
        empty: "The note is empty.",
      },
      // GAVION: lead edit (« Modifier »)
      edit: {
        button: "Edit",
        shortcut_hint: "Shortcut: E",
        title: "Edit lead",
        description:
          "System-managed fields (assignment, calls, score) cannot be edited here.",
        sections: {
          identity: "Company",
          coordinates: "Contact details",
          address: "Address",
          prospecting: "Prospecting",
          notes: "Internal notes",
        },
        fields: {
          name: "Company name",
          phone_number: "Phone",
          phone_hint: "10-digit North American number, e.g. 450 655-1865",
          email: "Email",
          website: "Website",
          address: "Address",
          city: "City",
          state_abbr: "Province",
          zipcode: "Postal code",
          region: "Region",
          sector: "Trade",
          sector_none: "— None —",
          timezone: "Time zone",
          language: "Language",
          language_fr: "French",
          language_en: "English",
          segment: "Segment",
          estimated_employees: "Employees (est.)",
          ops_contact_name: "Head of operations", // GAVION ops-lookup
          ops_contact_role: "Their role", // GAVION ops-lookup
          high_quality: "High quality",
          prospect_status: "Prospecting status",
          prospect_status_hint:
            "The displayed status also reflects the last call outcome.",
          prospect_status_dnc:
            "This lead is on the Do Not Call list: its status cannot be changed here.",
          description: "Description / internal notes",
        },
        cancel: "Cancel",
        save: "Save",
        saved: "Lead updated",
        no_changes: "No changes.",
        phone_taken: "This number already belongs to another lead",
        phone_taken_link: "View %{name}",
        errors: {
          name_required: "Company name is required.",
          ops_contact_too_long: "120 characters at most.", // GAVION ops-lookup
          phone_invalid:
            "Invalid number: enter a 10-digit North American number.",
          email_invalid: "Invalid email address.",
          status_dnc: "Use the « Do not call » action for this status.",
          forbidden:
            "You are not allowed to edit this lead or one of these fields.",
          generic: "The update failed. Please try again.",
          unknown_status:
            "This status was deleted meanwhile. Reload the page and pick another one.",
        },
      },
    },
    timeline: {
      title: "History",
      filters: {
        all: "All",
        calls: "Calls",
        notes: "Notes",
        emails: "Emails",
        meetings: "Meetings",
        tasks: "Tasks",
      },
      kind: {
        call: "Call",
        // GAVION batch 6
        meeting_note: "Granola notes",
        company_note: "Note",
        contact_note: "Contact note",
        deal_note: "Deal note",
        task: "Completed task",
      },
      empty: "No activity yet.",
      load_more: "Show more",
      error: "Could not load the history.",
      retry: "Retry",
      duration: "%{minutes} min %{seconds} s",
      by: "by %{name}",
      imported: "Imported",
    },
    lead_import: {
      button: "Import",
      title: "Import leads (CSV)",
      steps: {
        upload: "File",
        mapping: "Columns",
        options: "Options",
        preview: "Preview",
        import: "Import",
      },
      upload: {
        hint: "CSV in UTF-8 or Windows-1252, 20,000 rows max.",
        choose: "CSV file",
        too_large: "File too large — use the import script",
        empty: "The file has no rows.",
        encoding: "Detected encoding: %{encoding}",
        rows: "%{smart_count} row read |||| %{smart_count} rows read",
        read_error: "The file could not be read.",
      },
      mapping: {
        column: "File column",
        field: "Field",
        ignore: "Ignore",
        required: "Required: the name, and a phone or an email.",
        missing_required: "Map the name column and a phone or email column.",
        missing_column: "required column missing: %{column}",
      },
      fields: {
        name: "Company",
        trade: "Trade",
        phone: "Phone",
        email: "Email",
        website: "Website",
        city: "City",
        region: "Region",
        address: "Address",
        zipcode: "Postal code",
        owner_name: "Owner",
        estimated_employees: "Employees (est.)",
        high_quality: "High quality",
        segment: "Segment",
        source_query: "Source query",
        fit_score: "Score",
        date_added: "Date added",
        source_id: "Source ID",
      },
      options: {
        assign: "Assign to",
        unassigned: "Unassigned",
        tag: "Tag (optional)",
        no_tag: "None",
        duplicates: "Duplicates",
        skip: "Skip duplicates",
        fill_blanks: "Fill empty fields",
      },
      preview: {
        title: "Preview of the first 20 rows",
        row: "Row",
        status: "Status",
        valid: "%{smart_count} valid row |||| %{smart_count} valid rows",
        invalid:
          "%{smart_count} rejected row |||| %{smart_count} rejected rows",
        ok: "OK",
        will_update: "Will be completed",
        checking: "Checking numbers…",
      },
      reasons: {
        missing_name: "Missing name",
        missing_phone_or_email: "Phone or email required",
        invalid_phone: "Invalid phone",
        duplicate_in_file: "Duplicate in file",
        suppressed: "Number is on the do-not-call list",
        existing_lead: "Existing lead",
        invalid_row: "Invalid row",
        invalid_date: "Invalid date (YYYY-MM-DD)",
        ambiguous_phone: "Phone duplicated in the file and already in the CRM",
        not_sent: "Not sent",
        // GAVION import duplicates
        possible_duplicate: "Possible duplicate",
        match_gone: "Lead to complete not found",
      },
      // GAVION import duplicates: the report's "Possible duplicates" section
      duplicates: {
        title: "Possible duplicates (%{count})",
        intro:
          'These rows look like a lead already in the CRM. Choose what to do, then "Apply". Rows left on "Skip" stay in the rejected rows.',
        looks_like: "looks like",
        file_row: "row %{line} of the file",
        others: "+ %{smart_count} other |||| + %{smart_count} others",
        reason_name_city: "same name and city",
        reason_website: "same website and name",
        choice: "Decision for row %{line}",
        ignore: "Skip",
        fill: "Complete the existing lead",
        create: "Create anyway",
        apply_all: "Apply to all",
        apply: "Apply",
        applying: "Sending…",
        error: "Sending failed. Try again.",
        uncertain:
          "The connection dropped while sending: some rows may already have been created. Reload the companies list to check before retrying.",
      },
      run: {
        start: "Import %{smart_count} row |||| Import %{smart_count} rows",
        progress: "Importing… %{done} / %{total}",
        done: "Import finished",
        imported:
          "%{smart_count} lead imported |||| %{smart_count} leads imported",
        updated:
          "%{smart_count} lead completed |||| %{smart_count} leads completed",
        rejected:
          "%{smart_count} row rejected |||| %{smart_count} rows rejected",
        download_rejected: "Download rejected rows",
        reason_column: "Reason",
        error: "The import failed. Try again.",
        issue: "Line %{line}: %{reason}",
        stop: "Stop",
        cancelled: "Import stopped",
        not_sent:
          "%{smart_count} row not sent |||| %{smart_count} rows not sent",
      },
      nav: { next: "Next", back: "Back", close: "Close" },
    },
    // GAVION batch 4: per-feature catalogs (src/components/gavion/i18n/modules)
    nav: navEn,
    deals: dealsEn,
    deal_show: dealShowEn,
    deal_import: dealImportEn,
    reports: reportsEn,
    export: exportEn,
    dashboard: dashboardEn,
    dialer: dialerEn,
    softphone: softphoneEn,
    automation: automationEn,
    notifications: notificationsEn,
    health: healthEn,
    // GAVION: batch 7
    privacy: privacyEn,
    call_settings: callSettingsEn,
    // GAVION X1
    goals: goalsEn,
    // GAVION X3
    data_quality: dataQualityEn,
    // GAVION open-pixel
    email_settings: emailSettingsEn,
    // GAVION batch 6
    meetings: meetingsEn,
    // GAVION batch 3: M365 keys merged into the batch 6 integrations catalog (batch 6 wins on shared error keys)
    integrations: {
      ...integrationsM365En,
      ...integrationsEn,
      errors: { ...integrationsM365En.errors, ...integrationsEn.errors },
      // GAVION pw-reset-delegated
      system_sender: systemSenderEn,
      // GAVION stripe-sync
      stripe: stripeEn,
    },
    compose: composeEn,
    // GAVION batch 5
    email: emailEn,
    // GAVION X2
    objections: objectionsEn,
    // GAVION X5
    call_hours: callHoursEn,
    profile_password: profilePasswordEn,
    // GAVION training
    training: trainingEn,
    // GAVION rep stats
    rep_stats: repStatsEn,
    costs: costsEn,
    sessions: sessionsEn, // GAVION team sessions
    // GAVION ai-email
    ai: aiEn,
    call_brief: callBriefEn, // GAVION call-brief-pipeline
    send_pipeline: sendPipelineEn, // GAVION call-brief-pipeline
    booking: bookingEn, // GAVION booking
    test_mode: testModeEn, // GAVION test mode
    pipeline: pipelineEn, // GAVION custom pipeline
    lead_statuses: leadStatusesEn, // GAVION lead statuses
    // GAVION commissions (each screen task owns its module)
    commissions: commissionsEn,
    commissions_settings: commissionsSettingsEn,
    commissions_client: commissionsClientEn,
    commissions_reports: commissionsReportsEn,
    recruiting: recruitingEn, // GAVION recruiting
    email_archive: emailArchiveEn, // GAVION full-email
    callbacks: callbacksEn, // GAVION skip-callback
    tasks: tasksEn, // GAVION tasks page
  },
} as const;
